class CartUpsell extends HTMLElement {
    constructor() {
        super();
        this.loaded = false;
        this.observer = null;
    }

    connectedCallback() {
        if (this.loaded) return;

        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.01) {
                    console.log("CartUpsell is 1% in view");
                    this.loadUpsell();
                    observer.unobserve(this);
                }
            });
        }, {
            threshold: [0.01]
        });

        this.observer.observe(this);
    }

    loadUpsell() {
        if (this.loaded) return;
        this.loaded = true;

        const url = this.dataset.url;
        console.log(url, "URL URL");

        if (!url) return;

        fetch(url)
            .then(res => res.text())
            .then(html => {
                console.log(html);
                const wrapper = document.createElement('div');
                wrapper.innerHTML = html;
                console.log(wrapper);

                const fetchedUpsell = wrapper.querySelector('cart-upsell');

                if (!fetchedUpsell) {
                    this.remove(); // nothing useful → remove
                    return;
                }
                if (fetchedUpsell) {
                    console.log(fetchedUpsell, "FETCHED UPSELL");
                    this.innerHTML = fetchedUpsell.innerHTML;

                    // Move quick-add-modal to body to escape cart drawer transform
                    const modals = this.querySelectorAll('quick-add-modal');
                    modals.forEach(modal => document.body.appendChild(modal));

                    const listItem = this.querySelectorAll('.complementary-slide > ul > li');
                    console.log(listItem, listItem.length);
                    if (!listItem || !listItem.length) { this.remove(); } else { this.querySelector('[loading-ele]')?.classList.add('hidden'); }
                }
            })
            .catch(err => console.error(err));
    }
}

customElements.define('cart-upsell', CartUpsell);
